import FacilityInfo from "@/views/reporting/ResidentialHauler/FacilityInfo.vue";
import Materials from "@/views/reporting/ResidentialHauler/Materials.vue";

export default {
    FacilityInfo,
    Materials
}